import mobile_util from './mobile_util'
import MobileModalShare from '../share/mobile_modal_share'

function gaTracking(action, label, value, isNonInteractive) {
  var _gaq = window._gaq || [];
  label += "";
  _gaq.push([
    "_trackEvent",
    "mobile_swiping_slideview",
    action,
    label,
    value,
    !!isNonInteractive,
  ]);
}

$(document).ready( function(event) { 
  // var splashEndConfig, splashSaveConfig, splashSave;
  mobile_util.lazyloadImages('.j-lazy-related, .j-lazy-author', 200);

  var slideshowRatio = 225 / 300;
  const slideshare_mobile_object = window.slideshare_mobile_object;

  var viewOrientation = window.orientation === 0 || window.orientation === undefined ? '_portrait' : '_landscape';
  gaTracking('page_load' + viewOrientation, slideshare_mobile_object.slideshow.slideshowTitle, undefined, true);

  // Thumbnails only shown in portrait mode, so we want the min width or height of the screen
  var slideshowWidth = window.innerHeight > 0 ? Math.min(window.innerHeight, window.innerWidth) :
    Math.min(screen.height, screen.width);
  slideshowWidth *= 0.35;
  slideshowWidth = Math.min(slideshowWidth, 150);
  $(".thumbnail").width(slideshowWidth);
  $(".thumbnail").height(Math.floor(slideshowWidth * slideshowRatio));
  $('.slideshow-item .meta').css('margin-left', slideshowWidth);

  // Share button
  var mobile_modal_share = new MobileModalShare({
    shareBtn: '.j-share',
    parentEl: '.action-btns-container',
    el: '.j-mobileShare'
  });

  function saveSlideshow() {
    var url = $('.j-save').data("saveurl");
    mobile_util.addSpinnerTo('.player', 'M');
    $.ajax({
      url: url,
      success: function(e) {
        mobile_util.removeSpinnersFrom('.player');

        // Need this here to allow spinner to hide before pop-up
        setTimeout(function() { alert('Presentation saved to your profile.'); }, 250);
        gaTracking('save_success');
      },
      error: function(e) {
        mobile_util.removeSpinnersFrom('.player');

        // Need this here to allow spinner to hide before pop-up
        setTimeout(function() { alert('Failed to save Presentation. Please try again later.'); }, 250);
        gaTracking('save_failed');
      }
    });
  }

  // Check if the user has just logged in through a "save" click
  // If so, save the slideshow to their profile
  if (slideshare_mobile_object.user.id && cookie("login_from_download") &&
    cookie("login_from_download") == slideshare_mobile_object.slideshow.slideshowId) {
    saveSlideshow();
  }
  // Clear the cookie
  cookie("login_from_download", "", { path: '/' });

  $('.j-save').click(function(e) {
    e.preventDefault();

    gaTracking('save_click');

    var loginPath = $(this).data('saveurl');
    if(/\/login/.test(loginPath)) {
      // set cookie so that the save will be remembered when user logs in
      var expireTime = new Date(new Date().getTime() + 5*60*1000);
      cookie("login_from_download", slideshare_mobile_object.slideshow.slideshowId, { path: '/', expires: expireTime });

      window.location.href = loginPath;

      return;
    }

    saveSlideshow();
  });

  $('.related-bar').click(function() {
    var headerHeight = $('#mobile-header').height();
    $("html, body").animate({ scrollTop: $('#related-slideshows').position().top - headerHeight + 'px' });
  });

  // Tracking
  $('.slideshow-author').on('click', function() {
    gaTracking('more_from_user_click');
  });
  $('.j-related').on('click', '.j-slideshow-link', function() {
    gaTracking('related_click');
  });
  $('.j-share').on('click', function() {
    gaTracking('share_click');
  });

  // Toggle Like button
  var $likes = $('.j-like');
  $likes.on('click', function() {
    gaTracking('like_click');
    // Redirect to login if not signed in
    if(slideshare_mobile_object.user.id === '') {
      // set cookie so that the like will be saved
      var eventConfig = {
        "event" : "like",
        "data" : { "slideshow_id" : slideshare_mobile_object.slideshow.slideshowId }
      };
      var jsonString = JSON.stringify(eventConfig);
      cookie("after_login_action", jsonString, { path:'/' });

      var loginPath = '/login?from_source=' + encodeURIComponent(window.location.pathname);

      window.location.href = loginPath;
      return;
    }

    var $el = $(this);
    var is_liked = $el.hasClass('active');
    var text, url = '';
    var active = false;
    if(is_liked) { // Unlike
      text = 'Like';
      url = slideshare_mobile_object.favorites.delete_url;
    } else { // Like
      text = 'Liked';
      active = true;
      url = slideshare_mobile_object.favorites.create_url;
    }
    $.post(url, {
      slideshow_id: slideshare_mobile_object.slideshow.slideshowId
    }).done(function() {
      $likes.toggleClass('active', active);
      $likes.find('.j-like-text').html(text);
      gaTracking('like_success');
    }).fail(function() {
      alert('Like Failed! Please try again later');
      gaTracking('like_failed');
    });
  });
});
